import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountryCodeSelectComponent } from './country-code-select.component';

@NgModule({
  declarations: [CountryCodeSelectComponent],
  exports: [CountryCodeSelectComponent],
  imports: [
    CommonModule
  ]
})
export class CountryCodeSelectModule { }
